import { Action } from '@ngrx/store';
import { CustomerManagerCompany } from '@model';

export enum CustomerManagerCompaniesActionTypes {
  CustomerManagerCompaniesLoadData = '[customerManagerCompanies] Load data',
  CustomerManagerCompaniesLoadSuccess = '[customerManagerCompanies] Load success',
  CustomerManagerCompaniesLoadFail = '[customerManagerCompanies] Load fail',

  CreateCustomerManagerCompany = '[CustomerManagerCompany] Create',
  CreateCustomerManagerCompanySuccess = '[CustomerManagerCompany] Create success',
  CreateCustomerManagerCompanyFail = '[CustomerManagerCompany] Create fail',

  DeleteCustomerManagerCompany = '[CustomerManagerCompany] Delete',
  DeleteCustomerManagerCompanySuccess = '[CustomerManagerCompany] Delete success',
  DeleteCustomerManagerCompanyFail = '[CustomerManagerCompany] Delete fail',

  UpdateCustomerManagerCompany = '[CustomerManagerCompany] Update',
  UpdateCustomerManagerCompanySuccess = '[CustomerManagerCompany] Update success',
  UpdateCustomerManagerCompanyFail = '[CustomerManagerCompany] Update fail'
}

export class CustomerManagerCompaniesLoadData implements Action {
  readonly type = CustomerManagerCompaniesActionTypes.CustomerManagerCompaniesLoadData;
  constructor(public payload: { customerId: string }) {}
}

export class CustomerManagerCompaniesLoadSuccess implements Action {
  readonly type = CustomerManagerCompaniesActionTypes.CustomerManagerCompaniesLoadSuccess;
  constructor(public payload: CustomerManagerCompany[]) {}
}

export class CustomerManagerCompaniesLoadFail implements Action {
  readonly type = CustomerManagerCompaniesActionTypes.CustomerManagerCompaniesLoadFail;
  constructor(public payload: any) {}
}

export class CreateCustomerManagerCompany implements Action {
  readonly type = CustomerManagerCompaniesActionTypes.CreateCustomerManagerCompany;
  constructor(public payload: CustomerManagerCompany) {}
}
export class CreateCustomerManagerCompanySuccess implements Action {
  readonly type = CustomerManagerCompaniesActionTypes.CreateCustomerManagerCompanySuccess;
  constructor(public payload: CustomerManagerCompany) {}
}
export class CreateCustomerManagerCompanyFail implements Action {
  readonly type = CustomerManagerCompaniesActionTypes.CreateCustomerManagerCompanyFail;
  constructor(public payload: any) {}
}

export class DeleteCustomerManagerCompany implements Action {
  readonly type = CustomerManagerCompaniesActionTypes.DeleteCustomerManagerCompany;
  constructor(public payload: CustomerManagerCompany) {}
}
export class DeleteCustomerManagerCompanySuccess implements Action {
  readonly type = CustomerManagerCompaniesActionTypes.DeleteCustomerManagerCompanySuccess;
  constructor(public payload: CustomerManagerCompany) {}
}
export class DeleteCustomerManagerCompanyFail implements Action {
  readonly type = CustomerManagerCompaniesActionTypes.DeleteCustomerManagerCompanyFail;
  constructor(public payload: any) {}
}

export class UpdateCustomerManagerCompany implements Action {
  readonly type = CustomerManagerCompaniesActionTypes.UpdateCustomerManagerCompany;
  constructor(public payload: CustomerManagerCompany) {}
}
export class UpdateCustomerManagerCompanySuccess implements Action {
  readonly type = CustomerManagerCompaniesActionTypes.UpdateCustomerManagerCompanySuccess;
  constructor(public payload: CustomerManagerCompany) {}
}
export class UpdateCustomerManagerCompanyFail implements Action {
  readonly type = CustomerManagerCompaniesActionTypes.UpdateCustomerManagerCompanyFail;
  constructor(public payload: any) {}
}

export type CustomerManagerCompaniesActions =
  | CustomerManagerCompaniesLoadData
  | CustomerManagerCompaniesLoadSuccess
  | CustomerManagerCompaniesLoadFail
  | CreateCustomerManagerCompany
  | CreateCustomerManagerCompanySuccess
  | CreateCustomerManagerCompanyFail
  | DeleteCustomerManagerCompany
  | DeleteCustomerManagerCompanySuccess
  | DeleteCustomerManagerCompanyFail
  | UpdateCustomerManagerCompany
  | UpdateCustomerManagerCompanySuccess
  | UpdateCustomerManagerCompanyFail;
